__turbopack_context__.v({
  "pdf-document-content": "pdf-preview-module-scss-module__sGX8RG__pdf-document-content",
  "pdf-document-content--locale-adjusted-font": "pdf-preview-module-scss-module__sGX8RG__pdf-document-content--locale-adjusted-font",
  "pdf-document-content--printable": "pdf-preview-module-scss-module__sGX8RG__pdf-document-content--printable",
});
